import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#D0CAE4',
} as const

export const resources = {
  loginBg: '/images/oceread/login/login-bg.webp',
  logo: '',
  novel: '',
  facebookIcon: '/images/oceread/login/icon-facebook-logo.png',
  googleIcon: '/images/oceread/login/icon-google-logo.png',
  appleIcon: '/images/oceread/login/icon-apple-logo.png',
  emailIcon: '/images/oceread/login/icon-email.png',
  emailCodeIcon: '/images/oceread/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
